<template>
  <div class="auth-art hidden lg:block" aria-hidden="true">
    <div class="auth-glow auth-glow--blue"></div>
    <div class="auth-glow auth-glow--orange"></div>
    <div class="auth-grid"></div>

    <div class="auth-ribbon auth-ribbon--one"></div>
    <div class="auth-ribbon auth-ribbon--two"></div>
    <div class="auth-ribbon auth-ribbon--three"></div>

    <div class="auth-illustration">
      <svg viewBox="0 0 480 360" fill="none" xmlns="http://www.w3.org/2000/svg">
        <defs>
          <linearGradient id="auth-ink-body" x1="120" y1="90" x2="230" y2="260" gradientUnits="userSpaceOnUse">
            <stop stop-color="#6982FF"/>
            <stop offset="1" stop-color="#3B5BFF"/>
          </linearGradient>
          <linearGradient id="auth-paper" x1="280" y1="70" x2="420" y2="270" gradientUnits="userSpaceOnUse">
            <stop stop-color="#FFFFFF"/>
            <stop offset="1" stop-color="#F7F8FC"/>
          </linearGradient>
        </defs>

        <ellipse cx="250" cy="332" rx="176" ry="13" fill="#0B1020" opacity=".07"/>
        <path d="M58 330H424" stroke="#0B1020" stroke-width="4" stroke-linecap="round"/>

        <g transform="translate(268 58) rotate(2)">
          <rect width="166" height="214" rx="10" fill="url(#auth-paper)" stroke="#0B1020" stroke-width="4"/>
          <g stroke="#98A2B3" stroke-width="3" stroke-linecap="round">
            <path d="M18 20V10H28"/>
            <path d="M138 10H148V20"/>
            <path d="M148 194V204H138"/>
            <path d="M28 204H18V194"/>
          </g>
          <rect x="26" y="42" width="82" height="9" rx="4.5" fill="#DDE3FF"/>
          <rect x="26" y="60" width="114" height="6" rx="3" fill="#E7EAF3"/>
          <rect x="26" y="74" width="96" height="6" rx="3" fill="#E7EAF3"/>
          <rect x="26" y="96" width="114" height="48" rx="7" fill="#F2F5FF"/>
          <circle cx="58" cy="120" r="13" fill="#3B5BFF" opacity=".2"/>
          <path d="M82 112H128M82 122H116M82 132H104" stroke="#BCC7FF" stroke-width="5" stroke-linecap="round"/>
          <g transform="translate(26 164)">
            <rect width="22" height="34" rx="4" fill="#00AEEF"/>
            <rect x="27" width="22" height="34" rx="4" fill="#EC008C"/>
            <rect x="54" width="22" height="34" rx="4" fill="#FFE600"/>
            <rect x="81" width="22" height="34" rx="4" fill="#111827"/>
          </g>
          <path d="M26 212H140" stroke="#0B1020" stroke-width="3" stroke-linecap="round" opacity=".18"/>
        </g>

        <path d="M300 272L268 330M398 272L430 330M286 307H414" stroke="#0B1020" stroke-width="7" stroke-linecap="round"/>

        <g>
          <path
              d="M170 78C137 134 112 169 112 204C112 239 138 264 170 264C202 264 228 239 228 204C228 169 203 134 170 78Z"
              fill="url(#auth-ink-body)"
              stroke="#0B1020"
              stroke-width="4"
              stroke-linejoin="round"
          />
          <ellipse cx="152" cy="205" rx="11" ry="12" fill="#fff"/>
          <ellipse cx="188" cy="205" rx="11" ry="12" fill="#fff"/>
          <circle cx="154" cy="207" r="4.5" fill="#0B1020"/>
          <circle cx="190" cy="207" r="4.5" fill="#0B1020"/>
          <path d="M158 226C164 232 176 232 182 226" stroke="#0B1020" stroke-width="4" stroke-linecap="round"/>
          <path d="M136 160C144 152 156 148 168 149" stroke="#fff" stroke-opacity=".55" stroke-width="6" stroke-linecap="round"/>

          <path d="M122 212C108 218 98 227 92 238" stroke="#0B1020" stroke-width="4" stroke-linecap="round"/>
          <circle cx="88" cy="242" r="7" fill="#fff" stroke="#0B1020" stroke-width="3"/>
          <path d="M218 212C232 206 242 198 248 188" stroke="#0B1020" stroke-width="4" stroke-linecap="round"/>
          <circle cx="252" cy="184" r="7" fill="#fff" stroke="#0B1020" stroke-width="3"/>

          <g transform="translate(48 230) rotate(-18)">
            <rect width="18" height="54" rx="5" fill="#00AEEF" stroke="#0B1020" stroke-width="3"/>
            <rect x="20" width="18" height="54" rx="5" fill="#EC008C" stroke="#0B1020" stroke-width="3"/>
            <rect x="40" width="18" height="54" rx="5" fill="#FFE600" stroke="#0B1020" stroke-width="3"/>
            <circle cx="9" cy="59" r="4" fill="#0B1020"/>
          </g>

          <path d="M158 258L154 292M182 258L186 292" stroke="#0B1020" stroke-width="5" stroke-linecap="round"/>
          <path d="M145 296H164M176 296H195" stroke="#0B1020" stroke-width="6" stroke-linecap="round"/>
        </g>

        <g transform="translate(42 286)">
          <path d="M0 20L24 8L98 8L74 20H0Z" fill="#fff" stroke="#0B1020" stroke-width="3" stroke-linejoin="round"/>
          <path d="M0 20V34L74 34V20M74 20L98 8V22L74 34" stroke="#0B1020" stroke-width="3" stroke-linejoin="round"/>
          <path d="M14 16H58M20 26H64" stroke="#BCC7FF" stroke-width="4" stroke-linecap="round"/>
        </g>

        <g fill="#3B5BFF">
          <path d="M84 96L88 108L100 112L88 116L84 128L80 116L68 112L80 108L84 96Z"/>
          <path d="M420 140L423 149L432 152L423 155L420 164L417 155L408 152L417 149L420 140Z" fill="#FF7A45"/>
        </g>
        <circle cx="404" cy="92" r="5" fill="#FF7A45"/>
        <circle cx="106" cy="160" r="4" fill="#7C5CFF"/>
        <path d="M224 92V104M218 98H230" stroke="#0B1020" stroke-width="3" stroke-linecap="round" opacity=".38"/>
      </svg>
    </div>

    <div class="auth-quote">
      <p>把重复交给工具，<br>把判断留给你。</p>
      <span>EPRINTTOOLS</span>
    </div>

    <i class="auth-particle auth-particle--one"></i>
    <i class="auth-particle auth-particle--two"></i>
    <i class="auth-particle auth-particle--three"></i>
    <i class="auth-cross auth-cross--one"></i>
    <i class="auth-cross auth-cross--two"></i>
  </div>
</template>

<style scoped>
.auth-art {
  position: relative;
  min-height: 590px;
  overflow: visible;
  perspective: 1000px;
  pointer-events: none;
}

.auth-art::before {
  content: "";
  position: absolute;
  inset: 0;
  z-index: -2;
  background:
      linear-gradient(rgba(59, 91, 255, 0.04) 1px, transparent 1px),
      linear-gradient(90deg, rgba(59, 91, 255, 0.04) 1px, transparent 1px);
  background-size: 46px 46px;
  mask-image: radial-gradient(ellipse 68% 62% at 50% 50%, #000 25%, transparent 82%);
  -webkit-mask-image: radial-gradient(ellipse 68% 62% at 50% 50%, #000 25%, transparent 82%);
}

.auth-glow {
  position: absolute;
  border-radius: 50%;
  filter: blur(40px);
  pointer-events: none;
}

.auth-glow--blue {
  width: 500px;
  height: 500px;
  left: -170px;
  top: -140px;
  background: radial-gradient(circle, rgba(59, 91, 255, 0.22), transparent 68%);
  animation: auth-breathe 14s ease-in-out infinite;
}

.auth-glow--orange {
  width: 460px;
  height: 460px;
  right: -150px;
  bottom: -180px;
  background: radial-gradient(circle, rgba(255, 122, 69, 0.18), transparent 68%);
  animation: auth-breathe 16s ease-in-out -6s infinite;
}

.auth-ribbon {
  position: absolute;
  left: 50%;
  top: 42%;
  border-radius: 50%;
  pointer-events: none;
  transform-style: preserve-3d;
}

.auth-ribbon--one {
  width: 460px;
  height: 460px;
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 16px), #000 0);
  mask: radial-gradient(farthest-side, transparent calc(100% - 16px), #000 0);
  background: conic-gradient(from 210deg, rgba(59, 91, 255, 0), rgba(59, 91, 255, 0.9), rgba(124, 92, 255, 0.85), rgba(255, 122, 69, 0.9), rgba(255, 122, 69, 0));
  opacity: 0.5;
  filter: blur(.2px) drop-shadow(0 0 10px rgba(59, 91, 255, 0.22));
  animation: auth-ribbon-one 28s linear infinite;
}

.auth-ribbon--two {
  width: 360px;
  height: 360px;
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 12px), #000 0);
  mask: radial-gradient(farthest-side, transparent calc(100% - 12px), #000 0);
  background: conic-gradient(from 20deg, rgba(255, 122, 69, 0), rgba(255, 122, 69, 0.85), rgba(124, 92, 255, 0.8), rgba(59, 91, 255, 0.85), rgba(59, 91, 255, 0));
  opacity: 0.42;
  filter: blur(.3px) drop-shadow(0 0 10px rgba(255, 122, 69, 0.18));
  animation: auth-ribbon-two 34s linear infinite;
}

.auth-ribbon--three {
  width: 270px;
  height: 270px;
  -webkit-mask: radial-gradient(farthest-side, transparent calc(100% - 9px), #000 0);
  mask: radial-gradient(farthest-side, transparent calc(100% - 9px), #000 0);
  background: conic-gradient(from 120deg, rgba(59, 91, 255, 0), rgba(124, 92, 255, 0.8), rgba(255, 122, 69, 0.75), rgba(59, 91, 255, 0));
  opacity: 0.36;
  animation: auth-ribbon-three 24s linear infinite;
}

.auth-illustration {
  position: absolute;
  left: 50%;
  top: 40%;
  z-index: 2;
  width: min(420px, 74%);
  transform: translate(-50%, -50%);
  animation: auth-illustration-float 9s ease-in-out infinite;
}

.auth-illustration svg {
  display: block;
  width: 100%;
  height: auto;
  overflow: visible;
}

.auth-quote {
  position: absolute;
  left: 50%;
  top: 68%;
  z-index: 2;
  width: min(440px, 78%);
  transform: translateX(-50%);
  text-align: center;
}

.auth-quote p {
  margin: 0 0 14px;
  color: var(--ink);
  font-family: var(--font-display);
  font-size: clamp(18px, 1.8vw, 24px);
  font-weight: 600;
  letter-spacing: -0.02em;
  line-height: 1.65;
}

.auth-quote span {
  color: var(--subtle);
  font-family: var(--mono, monospace);
  font-size: 9px;
  letter-spacing: 0.2em;
}

.auth-particle {
  position: absolute;
  width: 7px;
  height: 7px;
  border-radius: 50%;
  background: var(--brand);
  box-shadow: 0 0 0 6px rgba(59, 91, 255, 0.1);
  animation: auth-particle-float 8s ease-in-out infinite;
}

.auth-particle--one {
  left: 14%;
  top: 22%;
}

.auth-particle--two {
  right: 12%;
  top: 62%;
  background: var(--accent);
  box-shadow: 0 0 0 6px rgba(255, 122, 69, 0.1);
  animation-delay: -3s;
}

.auth-particle--three {
  left: 22%;
  bottom: 16%;
  width: 5px;
  height: 5px;
  opacity: 0.7;
  animation-delay: -5s;
}

.auth-cross {
  position: absolute;
  width: 16px;
  height: 16px;
  opacity: 0.4;
}

.auth-cross::before,
.auth-cross::after {
  content: "";
  position: absolute;
  background: rgba(11, 16, 32, 0.45);
}

.auth-cross::before {
  left: 7px;
  top: 0;
  width: 1px;
  height: 16px;
}

.auth-cross::after {
  left: 0;
  top: 7px;
  width: 16px;
  height: 1px;
}

.auth-cross--one {
  left: 8%;
  top: 10%;
}

.auth-cross--two {
  right: 9%;
  bottom: 14%;
}

@keyframes auth-ribbon-one {
  from { transform: translate(-50%, -50%) rotateX(64deg) rotateZ(16deg); }
  to { transform: translate(-50%, -50%) rotateX(64deg) rotateZ(376deg); }
}

@keyframes auth-ribbon-two {
  from { transform: translate(-50%, -50%) rotateX(58deg) rotateZ(-28deg); }
  to { transform: translate(-50%, -50%) rotateX(58deg) rotateZ(-388deg); }
}

@keyframes auth-ribbon-three {
  from { transform: translate(-50%, -50%) rotateX(72deg) rotateZ(8deg); }
  to { transform: translate(-50%, -50%) rotateX(72deg) rotateZ(368deg); }
}

@keyframes auth-illustration-float {
  0%, 100% { transform: translate(-50%, -50%) translateY(0); }
  50% { transform: translate(-50%, -50%) translateY(-8px); }
}

@keyframes auth-particle-float {
  0%, 100% { transform: translateY(0); opacity: 0.55; }
  50% { transform: translateY(-14px); opacity: 1; }
}

@keyframes auth-breathe {
  0%, 100% { transform: scale(1); opacity: 0.85; }
  50% { transform: scale(1.06); opacity: 1; }
}

@media (prefers-reduced-motion: reduce) {
  .auth-ribbon,
  .auth-illustration,
  .auth-particle,
  .auth-glow {
    animation: none;
  }
}
</style>
